import { createAsyncThunk } from '@reduxjs/toolkit';
import { ShippingMethod } from '../domain/entities/ShippingMethod';
import { FindShippingAreaDto } from '../../shipping_area/data/ShippingAreaDto';
import { ShippingAreaService } from '../../shipping_area/data/ShippingAreaService';

export const findShippingMethodsThunk = createAsyncThunk(
    'shipping_method/search',
    async (filters: FindShippingAreaDto): Promise<ShippingMethod[]> => 
        (await ShippingAreaService.findShippingAreaAsync(filters)).shippingMethods
);